module.exports = __webpack_public_path__ + "img/imgZXGH(16).94691669.png";